import t,{useMemo as e}from"react";import{makeColumnClasses as r}from"./utils/index.js";const i=({children:i,width:o})=>{const s=e((()=>r(o)),[o]);return t.createElement("div",{className:s},i)};export{i as default};
